
const translations = {
  nav_about: "À propos",
  nav_services: "Services",
  nav_method: "Méthode",
  nav_library: "Bibliothèque",
  nav_contact: "Contact",
  nav_login: "Se connecter",
  nav_register: "S'inscrire",
  nav_my_profile: "Mon profil",
  nav_availability: "Statut de disponibilité",
  nav_processes: "Mes processus",
  nav_edit: "Modifier les informations",
  nav_privacy: "Politique de confidentialité",
  nav_logout: "Se déconnecter",
  nav_company_account: "Compte entreprise",
  nav_professional_account: "Compte professionnel",
  hero_badge: "International Placement",
  hero_title_1: "Sélection stratégique de talents en Europe",
  hero_title_2: "International Placement",
  hero_subtitle: "Cabinet stratégique de sélection et placement international en Europe.",
  hero_markets: "Allemagne · Suisse · Pays-Bas · Autriche · Belgique",
  hero_cta_talent: "Rechercher des talents",
  hero_cta_explore: "Explorer les opportunités",
  hero_social_proof: "+120 professionnels placés en Europe",
};

export default translations;
